import React, { Suspense, lazy } from 'react';
import PagePreloader from '~components/page-preloader';

const LawsItemPageToken = lazy(() => import('./index'))

function LawsItemPageTokenLazy(props) {
    return (
        <Suspense fallback={<PagePreloader />}>
            <LawsItemPageToken {...props} />
        </Suspense>
    );
}

export default LawsItemPageTokenLazy;
export { LawsItemPageTokenLazy };



// WEBPACK FOOTER //
// ./src/routes/laws-item-page-token/lazy.js